<template>
  <div class="c-swipe">
    <swipe
            :speed="speed"
            :auto="auto"
            :continuous="continuous"
            :showIndicators="showIndicators"
            :prevent="prevent">
      <swipe-item v-for="(item, index) in images"
                  @click.native="handleClick(index)" :key="index">
        <img :src="item">
      </swipe-item>
    </swipe>
  </div>
</template>

<script>
  import { Swipe, SwipeItem } from 'vue-swipe'
  import 'vue-swipe/dist/vue-swipe.css'
  export default {
    name: 'c-swipe',
    components: {Swipe, SwipeItem},
    props: {
      images: {
        type: Array,
        default: () => []
      },
      auto: {
        type: Number,
        default: 3000
      },
      speed: {
        type: Number,
        default: 300
      },
      continuous: {
        type: Boolean,
        default: true
      },
      showIndicators: {
        type: Boolean,
        default: true
      },
      prevent: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      handleClick (index) {
        this.$emit('click', index)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './index';
</style>



// WEBPACK FOOTER //
// index.vue?ac31d72a